import { useEffect, useState } from "react";
import Footer from "../../components/Footer";
import { getAllCategories } from "../../services/categoryServices";
import HomeMain from "./HomeMain";
import Cookies from "js-cookie";
import { getAllEvents } from "../../services/eventsServices";
import { getAllNews } from "../../services/newsServices";
import { getCurrentOfficeBears } from "../../services/memberServices";
import Header from "../../components/Header";
// import popupImage1 from "../../assets/img/Announcement.jpg";
// import popupImage2 from "../../assets/img/brochure2.jpg";
// import { Modal, Button } from "react-bootstrap";
// import Slider from "react-slick";

const Home = () => {
  const [events, setEvents] = useState([]);
  const [news, setNews] = useState([]);
  const [leadership, setLeadership] = useState([]);
  const [ecMembers, setEcMembers] = useState([]);
  const [pastPresidents, setPastPresidents] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(true);
  }, []);

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    document.title = "Home | Society of Aquaculture Professionals";
    const fetchData = async () => {
      try {
        const token = Cookies.get("token");
        const email = Cookies.get("email");
        const role = Cookies.get("role");
        const isLoggedIn = token && email && role;

        const [eventsResult, newsResult, officeResult, categoriesResult] =
          await Promise.allSettled([
            getAllEvents({ limit: 4, homepage: true, status: "active" }),
            getAllNews({
              limit: 6,
              visibility: isLoggedIn ? "" : "public",
              homepage: true,
              status: "approved",
            }),
            getCurrentOfficeBears(),
            getAllCategories(),
          ]);

        if (eventsResult.status === "fulfilled") {
          setEvents(eventsResult.value.data.data || []);
        }
        if (newsResult.status === "fulfilled") {
          setNews(newsResult.value.data.items || []);
        }
        if (officeResult.status === "fulfilled") {
          const officeData = officeResult.value || {};
          setLeadership(officeData.data || []);
          setEcMembers(officeData.ecMembers || []);
          setPastPresidents(officeData.pastPresidents || []);
        }
        if (categoriesResult.status === "fulfilled") {
          setCategories(categoriesResult.value.data || []);
        }
      } catch (err) {
        console.error("Unexpected error:", err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // const sliderSettings = {
  //   dots: true,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 1,
  //   arrows: false,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   autoplaySpeed: 1700,
  // };

  return (
    <div>
      <Header />
      {/* <Modal
        show={isOpen}
        onHide={toggleModal}
        centered
        size="md"
        dialogClassName="edge-to-edge-modal"
        backdropClassName="no-backdrop-padding"
      >
        <Modal.Body className="p-2 position-relative">
          <Button
            variant="light"
            onClick={toggleModal}
            style={{
              position: "absolute",
              top: "20px",
              right: "20px",
              zIndex: 2,
              borderRadius: "50%",
              padding: "0.3rem 0.6rem",
              boxShadow: "0 0 10px rgba(0,0,0,0.2)",
              fontSize: "20px",
              fontWeight: "bold",
            }}
          >
            ✕
          </Button>

          <Slider {...sliderSettings}>
            <div>
              <img
                src={popupImage1}
                alt="Popup 1"
                style={{
                  width: "100%",
                  height: "600px",
                  objectFit: "cover",
                }}
              />
            </div>
            <div>
              <img
                src={popupImage2}
                alt="Popup 2"
                style={{
                  width: "100%",
                  height: "600px", // same height
                  objectFit: "cover",
                }}
              />
            </div>
          </Slider>
        </Modal.Body>
      </Modal> */}

      <HomeMain
        events={events}
        news={news}
        leadership={leadership}
        ecMembers={ecMembers}
        pastPresidents={pastPresidents}
        categories={categories}
      />
      <Footer />
    </div>
  );
};

export default Home;
